import { Component, EventEmitter, Input, Output, TemplateRef } from '@angular/core';
import { PStepContext } from '../model/p-step-config';
import { PStepState } from '../p-stepper/p-step-state.enum';

@Component({
    selector: 'p-step',
    template: `
        <div class="p-step" [ngClass]="state">
            <div class="step-number">
                <div class="number">
                    <span class="p-paragraph-1 p-tpgr-semibold" *ngIf="state != pStepState.completed; else completedMarker">{{
                        index + 1
                    }}</span>
                    <ng-template #completedMarker>
                        <p-icon iconName="check" size="md" color="base-light"></p-icon>
                    </ng-template>
                </div>
                <div class="divider"></div>
                <div class="activeStepMarker" *ngIf="state === pStepState.active"></div>
            </div>
            <div class="step-box">
                <ng-container *ngTemplateOutlet="template; context: getContext()" #outletContent></ng-container>
            </div>
        </div>
    `,
    styleUrls: ['./p-step.component.scss']
})
export class PStepComponent {
    @Input() context!: PStepContext;
    @Input() template!: TemplateRef<PStepContext>;
    @Input() state!: PStepState;
    @Input() index!: number;

    public readonly pStepState = PStepState;

    public getContext(): PStepContext {
        return { ...this.context, state: this.state };
    }
}
